import { partialBlankBrush, partialBlank, partialError, partialForbidden, underReview, blank, clientError, forbidden, noResults, notFound, reviewError, reviewPending, reviewSuccess, serverError, imagePlaceholder, loading, spotBarChart, spotCleared, spotFunnelChart, spotGaugeChart, spotImageError, spotLineChart, spotLoadError, spotMap, spotNetworkError, spotNoAccess, spotNoContent, spotNoFavorites, spotNoHistory, spotNoImage, spotNoInternet, spotNoMessages, spotNoResults, spotNoStore, spotNoVideo, spotPieChart, spotPresentation, spotRadarChart, spotRelationshipChart, spotServerError, spotTryLater, spotVideoError, spotWordCloud } from 'dls-graphics';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};
function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}

var _excluded = ["class"],
    _excluded2 = ["title"],
    _excluded3 = ["staticClass", "class", "attrs"];
function createSVG(name, _ref) {
  var contents = _ref.contents,
      _ref$attrs = _ref.attrs,
      className = _ref$attrs["class"],
      intrinsicAttrs = _objectWithoutProperties(_ref$attrs, _excluded);

  return {
    functional: true,
    name: name,
    render: function render(h, _ref2) {
      var _ref2$data = _ref2.data,
          data = _ref2$data === void 0 ? {} : _ref2$data;
      var staticClass = data.staticClass,
          dynamicClass = data["class"],
          _data$attrs = data.attrs;
      _data$attrs = _data$attrs === void 0 ? {} : _data$attrs;

      var title = _data$attrs.title,
          attrs = _objectWithoutProperties(_data$attrs, _excluded2),
          rest = _objectWithoutProperties(data, _excluded3);

      var tabindex = attrs.tabindex;
      return h('svg', _objectSpread2({
        "class": [className, staticClass, dynamicClass],
        attrs: _objectSpread2(_objectSpread2({}, intrinsicAttrs), {}, {
          focusable: tabindex !== '0' ? 'false' : null
        }, attrs),
        domProps: {
          innerHTML: (title ? "<title>".concat(escapeHTML(title), "</title>") : '') + contents
        }
      }, rest));
    }
  };
}

var IllustrationPartialBlankBrush = /*#__PURE__*/createSVG('IllustrationPartialBlankBrush', partialBlankBrush);

var IllustrationPartialBlank = /*#__PURE__*/createSVG('IllustrationPartialBlank', partialBlank);

var IllustrationPartialError = /*#__PURE__*/createSVG('IllustrationPartialError', partialError);

var IllustrationPartialForbidden = /*#__PURE__*/createSVG('IllustrationPartialForbidden', partialForbidden);

var IllustrationUnderReview = /*#__PURE__*/createSVG('IllustrationUnderReview', underReview);

var IllustrationBlank = /*#__PURE__*/createSVG('IllustrationBlank', blank);

var IllustrationClientError = /*#__PURE__*/createSVG('IllustrationClientError', clientError);

var IllustrationForbidden = /*#__PURE__*/createSVG('IllustrationForbidden', forbidden);

var IllustrationNoResults = /*#__PURE__*/createSVG('IllustrationNoResults', noResults);

var IllustrationNotFound = /*#__PURE__*/createSVG('IllustrationNotFound', notFound);

var IllustrationReviewError = /*#__PURE__*/createSVG('IllustrationReviewError', reviewError);

var IllustrationReviewPending = /*#__PURE__*/createSVG('IllustrationReviewPending', reviewPending);

var IllustrationReviewSuccess = /*#__PURE__*/createSVG('IllustrationReviewSuccess', reviewSuccess);

var IllustrationServerError = /*#__PURE__*/createSVG('IllustrationServerError', serverError);

var IllustrationImagePlaceholder = /*#__PURE__*/createSVG('IllustrationImagePlaceholder', imagePlaceholder);

var IllustrationLoading = /*#__PURE__*/createSVG('IllustrationLoading', loading);

var IllustrationSpotBarChart = /*#__PURE__*/createSVG('IllustrationSpotBarChart', spotBarChart);

var IllustrationSpotCleared = /*#__PURE__*/createSVG('IllustrationSpotCleared', spotCleared);

var IllustrationSpotFunnelChart = /*#__PURE__*/createSVG('IllustrationSpotFunnelChart', spotFunnelChart);

var IllustrationSpotGaugeChart = /*#__PURE__*/createSVG('IllustrationSpotGaugeChart', spotGaugeChart);

var IllustrationSpotImageError = /*#__PURE__*/createSVG('IllustrationSpotImageError', spotImageError);

var IllustrationSpotLineChart = /*#__PURE__*/createSVG('IllustrationSpotLineChart', spotLineChart);

var IllustrationSpotLoadError = /*#__PURE__*/createSVG('IllustrationSpotLoadError', spotLoadError);

var IllustrationSpotMap = /*#__PURE__*/createSVG('IllustrationSpotMap', spotMap);

var IllustrationSpotNetworkError = /*#__PURE__*/createSVG('IllustrationSpotNetworkError', spotNetworkError);

var IllustrationSpotNoAccess = /*#__PURE__*/createSVG('IllustrationSpotNoAccess', spotNoAccess);

var IllustrationSpotNoContent = /*#__PURE__*/createSVG('IllustrationSpotNoContent', spotNoContent);

var IllustrationSpotNoFavorites = /*#__PURE__*/createSVG('IllustrationSpotNoFavorites', spotNoFavorites);

var IllustrationSpotNoHistory = /*#__PURE__*/createSVG('IllustrationSpotNoHistory', spotNoHistory);

var IllustrationSpotNoImage = /*#__PURE__*/createSVG('IllustrationSpotNoImage', spotNoImage);

var IllustrationSpotNoInternet = /*#__PURE__*/createSVG('IllustrationSpotNoInternet', spotNoInternet);

var IllustrationSpotNoMessages = /*#__PURE__*/createSVG('IllustrationSpotNoMessages', spotNoMessages);

var IllustrationSpotNoResults = /*#__PURE__*/createSVG('IllustrationSpotNoResults', spotNoResults);

var IllustrationSpotNoStore = /*#__PURE__*/createSVG('IllustrationSpotNoStore', spotNoStore);

var IllustrationSpotNoVideo = /*#__PURE__*/createSVG('IllustrationSpotNoVideo', spotNoVideo);

var IllustrationSpotPieChart = /*#__PURE__*/createSVG('IllustrationSpotPieChart', spotPieChart);

var IllustrationSpotPresentation = /*#__PURE__*/createSVG('IllustrationSpotPresentation', spotPresentation);

var IllustrationSpotRadarChart = /*#__PURE__*/createSVG('IllustrationSpotRadarChart', spotRadarChart);

var IllustrationSpotRelationshipChart = /*#__PURE__*/createSVG('IllustrationSpotRelationshipChart', spotRelationshipChart);

var IllustrationSpotServerError = /*#__PURE__*/createSVG('IllustrationSpotServerError', spotServerError);

var IllustrationSpotTryLater = /*#__PURE__*/createSVG('IllustrationSpotTryLater', spotTryLater);

var IllustrationSpotVideoError = /*#__PURE__*/createSVG('IllustrationSpotVideoError', spotVideoError);

var IllustrationSpotWordCloud = /*#__PURE__*/createSVG('IllustrationSpotWordCloud', spotWordCloud);

export { IllustrationBlank, IllustrationClientError, IllustrationForbidden, IllustrationImagePlaceholder, IllustrationLoading, IllustrationNoResults, IllustrationNotFound, IllustrationPartialBlank, IllustrationPartialBlankBrush, IllustrationPartialError, IllustrationPartialForbidden, IllustrationReviewError, IllustrationReviewPending, IllustrationReviewSuccess, IllustrationServerError, IllustrationSpotBarChart, IllustrationSpotCleared, IllustrationSpotFunnelChart, IllustrationSpotGaugeChart, IllustrationSpotImageError, IllustrationSpotLineChart, IllustrationSpotLoadError, IllustrationSpotMap, IllustrationSpotNetworkError, IllustrationSpotNoAccess, IllustrationSpotNoContent, IllustrationSpotNoFavorites, IllustrationSpotNoHistory, IllustrationSpotNoImage, IllustrationSpotNoInternet, IllustrationSpotNoMessages, IllustrationSpotNoResults, IllustrationSpotNoStore, IllustrationSpotNoVideo, IllustrationSpotPieChart, IllustrationSpotPresentation, IllustrationSpotRadarChart, IllustrationSpotRelationshipChart, IllustrationSpotServerError, IllustrationSpotTryLater, IllustrationSpotVideoError, IllustrationSpotWordCloud, IllustrationUnderReview, createSVG };
//# sourceMappingURL=index.esm.js.map
